import axios from "axios";
import { useMainStore } from "./mainStore";

/**
 * This can only be used after the token has been written into the state.
 * This happens when the Home.vue component is loaded.
 * It's tricky to do it earlier than this, because that's the first
 * rendered component and so it's the first time when URL parameters can be accessed normally.
 */
export const httpClient = function () {
	const store = useMainStore();

	let client = axios.create({
		baseURL: import.meta.env.VITE_APP_ERP_URL,
		headers: {
			Token: store.token,
			"X-User-Language": store.language,
		},
	});

	client.interceptors.response.use(
		function (response) {
			return response;
		},
		function (error) {
			console.error(error.request.responseURL);
			console.error(error.message);
			return Promise.reject(error);
		}
	);

	return client;
};
